// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"4c373539","324":"4f4761d8"}[chunkId] + ".css";
};